import { getProducersEngagement } from "./get-producers-engagement";
import { getProcessedQuarters } from "./get-processed-quarters";
export default {
    getProducersEngagement: getProducersEngagement,
    getProcessedQuarters: getProcessedQuarters
};
